export class Rhybudd {
    math: MathRhybudd;
    neges: string;
    cadwArOlNewidRoute: boolean;
    rhybuddId: string;

    constructor(init?: Partial<Rhybudd>) {
        Object.assign(this, init);
    }
}

export enum MathRhybudd {
    Llwyddiant,
    Gwall,
    Gwybodaeth,
    Rhybudd
}
